<form [formGroup]="incidentTaskForm" class="p-3">
  <div class="row border-bottom mb-3">
    <div class="col-lg-6">
      <div class="d-flex flex-column gap-4">
        <div>
          <app-form-switch formControlName="canCreateIncidents" labelPosition="before">
            <div i18n>Auto-create Incidents (From Guest Messages)</div>
            <div class="text-sm text-muted text-normal-bold" i18n>
              Uses AI to analyze guest messages and identify potential issues, such as complaints or service requests.
              When detected, an incident is automatically created for staff to address.
            </div>
          </app-form-switch>
          <div class="alert alert-secondary-primary" i18n>
            A message like “There’s no hot water” triggers an incident for a hot water issue.
          </div>
        </div>
        <div>
          <app-form-switch formControlName="canCreateIncidentsFromReviews" labelPosition="before">
            <div i18n>Auto-create Incidents (From Reviews)</div>
            <div class="text-sm text-muted text-normal-bold" i18n>
              AI analyzes guest feedback to find mentions of problems, like broken amenities or poor service. It then
              creates incidents automatically so your team can follow up.
            </div>
          </app-form-switch>
          <div class="alert alert-secondary-primary" i18n>
            A review saying “The AC didn’t work” results in an incident for the AC issue.
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 border-left">
      <div class="mb-3">
        <div class="form-field-label" i18n>Detection Sensitivity</div>
        <div class="text-sm text-muted" i18n>
          Adjust how strictly the AI is when detecting issues in guest messages & reviews.
        </div>
        <div class="d-flex flex-column">
          <mat-slider
            [max]="10"
            [min]="0"
            [step]="5"
            [tickInterval]="5"
            formControlName="detectionSensivity"
            class="p-0"
          >
          </mat-slider>
          <div class="d-flex justify-content-between">
            <div class="text-sm text-muted">Low</div>
            <div class="text-sm text-muted">Medium</div>
            <div class="text-sm text-muted">High</div>
          </div>
        </div>
        <div class="alert alert-secondary-primary mt-2">
          <div i18n>
            Controls how strictly AI flags issues in guest messages or reviews. Higher levels catch more potential
            problems and create more incidents automatically.
          </div>
          <div i18n>
            For example, on <b>High</b>, even a message like “Room was a bit noisy” could trigger an incident for a
            noise issue.
          </div>
        </div>
      </div>
      <div class="mb-3">
        <app-ai-incident-notification #incidentNotification></app-ai-incident-notification>
      </div>
    </div>
  </div>
  <div class="alert alert-secondary-info">
    <div i18n>
      Note: You can set more detailed rules, assignments, and automation for incidents in the Autopilot Wizard.
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button class="btn btn-secondary-info" (click)="onSave()" [disabled]="isSaving$ | async">
      <i *ngIf="isSaving$ | async" class="far fa-spin fa-spinner"></i>
      <i *ngIf="!(isSaving$ | async)" class="cs-icon cs-icon-save"></i>
      <span i18n>Save</span>
    </button>
  </div>
</form>
